// taken from niffer screens/EnterPaymentInformation
export const stripeErrorMessage = ({ code, message } = {}) => {
  let errorMessage = message;

  switch (code) {
    case 'card_declined':
    case 'incomplete_number':
      errorMessage = 'Your card number is invalid.';
      break;
    case 'expired_card':
    case 'incomplete_expiry':
    case 'invalid_expiry_year':
    case 'invalid_expiry_year_past':
      errorMessage = "Your card's expiration year is invalid.";
      break;
    case 'incomplete_cvc':
    case 'invalid_cvc':
    case 'incorrect_cvc':
      errorMessage = "Your card's security code is invalid.";
      break;
    default:
      break;
  }
  return errorMessage;
};
